// container.js - Updated with proper API response handling
import React, { useState, useCallback } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { toastr } from "react-redux-toastr";
import debounce from 'lodash/debounce';
import brandicon from "../../../../assests/brandicon.svg";
import mvidicon from "../../../../assests/mvidicon.svg";
import offerpriceicon from "../../../../assests/offerpriceicon.svg";
import producticon from "../../../../assests/producticon.svg";
import varianticon from "../../../../assests/varianticon.svg";
import WarehouseNewRuleCreationComponent from "./component";
import { format } from 'date-fns';
import { useNavigate, useParams } from "react-router-dom";

const WarehouseNewAssortmentRuleCreationContainer = (props) => {
  const navigate = useNavigate();
  const { reference_id } = useParams()
  const [formData, setFormData] = useState({
    startDate: new Date(),
    ruleType: "",
    names: [],
    slotCount: 1,
    validationType: "RESTRICTED",
    maxPrice: ""
  });
  const [searchInput, setSearchInput] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [errors, setErrors] = useState({
    ruleType: false,
    names: false,
    maxPrice: false,
    validationType: false
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [newRuleId, setNewRuleId] = useState(null);
  const [newWarehouseName, setNewWarehouseName] = useState(null);
  const [ruleFailureData, setRuleFailureData] = useState([]);
  const [lastUpdatedTime, setLastUpdatedTime] = useState('');
  const [showMaxItemsPopup, setShowMaxItemsPopup] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successData, setSuccessData] = useState({ id: '', name: '' });
  const [showRuleFailurePopup, setShowRuleFailurePopup] = useState(false);
  const [filteredMvList, setFilteredMvList] = useState([]);
  const [showMvIdDropdown, setShowMvIdDropdown] = useState(false);
  const [ruleFailures, setRuleFailures] = useState([]);
  const [showFailureModal, setShowFailureModal] = useState(false);

  const validateForm = () => {
    const newErrors = {
      ruleType: !formData.ruleType,
      names: formData.ruleType !== "OfferPrice" && formData.names.length === 0,
      maxPrice: formData.ruleType === "OfferPrice" && !formData.maxPrice,
      validationType: formData.ruleType !== "OfferPrice" && !formData.validationType
    };
    setErrors(newErrors);
    return !Object.values(newErrors).some(error => error);
  };

  const validateInput = (value) => {
    return /^[a-zA-Z0-9\s]*$/.test(value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === "maxPrice") {
      if (/^[0-9]*\.?[0-9]*$/.test(value) || value === "") {
        setFormData(prev => ({ ...prev, [name]: value }));
      }
      return;
    }
    
    if (validateInput(value) || value === "") {
      setFormData(prev => ({ ...prev, [name]: value }));
    }

    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: false }));
    }

    if (name === "ruleType") {
      setFormData(prev => ({
        ...prev,
        names: [],
        maxPrice: "",
        validationType: "RESTRICTED",
        slotCount: 1
      }));
      setSearchInput("");
      setShowDropdown(false);
      setShowMvIdDropdown(false);
      setSearchResults([]);
      setFilteredMvList([]);
    }
  };

  // 🔥 Search for Brand, Product, Variant (Debounced - Auto Search)
  const searchEntity = debounce((value) => {
    if (value.length > 0 && formData.ruleType && ["Brand", "Product", "Variant"].includes(formData.ruleType)) {
      setShowDropdown(true);
      setSearchLoading(true);

      let searchParam = '';
      let entityType = '';

      switch (formData.ruleType) {
        case "Brand":
          searchParam = value;
          entityType = 'brand';
          break;
        case "Product":
          searchParam = value;
          entityType = 'product';
          break;
        case "Variant":
          searchParam = value;
          entityType = 'variant';
          break;
        default:
          break;
      }

      const apiUrl = `/partner/api/v1/assortment/item/search?search=${encodeURIComponent(searchParam)}&searchEntityName=${entityType}`;

      props.getDataFromAPI(apiUrl, "GET", undefined, (response) => {
        // ✅ Handle response - Extract data from response.data if exists
        let data = [];
        if (response && response.status && response.status.success && response) {
          // If response has status wrapper
          data = response;
        } else if (Array.isArray(response)) {
          // If response is directly an array
          data = response;
        } else if (response && response && Array.isArray(response)) {
          // If response has data array
          data = response;
        }

        let results = [];
        if (Array.isArray(data)) {
          results = data.map(item => ({
            id: item.id || item.mvId,
            name: item.name || item.variantName || 'N/A'
          }));
        }

        setSearchResults(results);
        setSearchLoading(false);
      }, (err) => {
        console.error("Search error:", err);
        setSearchResults([]);
        setSearchLoading(false);
      });
    } else {
      setShowDropdown(false);
      setSearchResults([]);
    }
  }, 300);

  // 🔥 MVID Search - Called on button click or Enter key
  const handleMvidSearch = (value) => {
    if (!value || !value.trim()) {
      toastr.warning("Please enter a search term");
      return;
    }

    setShowMvIdDropdown(true);
    setSearchLoading(true);

    props.getDataFromAPI(
      `/partner/api/v2/productSearch/mvId?mvId=${encodeURIComponent(value.trim())}&search=${encodeURIComponent(value)}`,
      "GET",
      undefined,
      (response) => {
        console.log("MVID Search Response:", response);
        
        let results = [];
        
        // ✅ Handle response - Extract data from response.data if exists
        let data = [];
        if (response && response.status && response.status.success && response) {
          // If response has status wrapper
          data = response;
        } else if (response && response.list && Array.isArray(response.list)) {
          // If response has list array
          data = response.list;
        } else if (Array.isArray(response)) {
          // If response is directly an array
          data = response;
        } else if (response && response && Array.isArray(response)) {
          // If response has data array
          data = response;
        }

        if (Array.isArray(data)) {
          results = data.map(item => ({
            mvid: item.mvid || item.mvId || item.id,
            mvId: item.mvid || item.mvId || item.id,
            id: item.mvid || item.mvId || item.id,
            name: item.variant_name || item.name || item.variantName || 'N/A',
            variantName: item.variant_name || item.name || item.variantName || 'N/A'
          }));
        }
        
        console.log("Mapped Results:", results);
        setFilteredMvList(results);
        setSearchLoading(false);
        
        if (results.length === 0) {
          toastr.info("No results found for the given MVID");
        }
      },
      (err) => {
        console.error("MVID search error:", err);
        setFilteredMvList([]);
        setSearchLoading(false);
        toastr.error("Failed to search MVID. Please try again.");
      }
    );
  };

  const handleSearchInputChange = (e) => {
    const value = e.target.value;
    if (validateInput(value) || value === "") {
      setSearchInput(value);
      
      // 🔥 Only auto-search for non-MVID types
      if (formData.ruleType !== "MVID" && ["Brand", "Product", "Variant"].includes(formData.ruleType)) {
        searchEntity(value);
      }
    }
  };

  const handleAddName = (item) => {
    const itemId = item.mvid || item.mvId || item.id;
    const itemName = item.name || item.variantName || 'N/A';
    
    if (!formData.names.some(existingItem => (existingItem.mvid || existingItem.mvId || existingItem.id) === itemId)) {
      setFormData(prev => ({
        ...prev,
        names: [...prev.names, { 
          id: itemId, 
          mvid: itemId,
          mvId: itemId,
          name: itemName,
          variantName: itemName
        }]
      }));
      setErrors(prev => ({ ...prev, names: false }));
    }
    setSearchInput("");
    setShowDropdown(false);
    setShowMvIdDropdown(false);
    setFilteredMvList([]);
  };

  const handleRemoveName = (idToRemove) => {
    setFormData(prev => ({
      ...prev,
      names: prev.names.filter(item => (item.mvid || item.mvId || item.id) !== idToRemove)
    }));
  };

  const handleSlotCountChange = (delta) => {
    setFormData(prev => ({
      ...prev,
      slotCount: Math.max(1, prev.slotCount + delta)
    }));
  };

  const handleDateChange = (newValue) => {
    setFormData(prev => ({ ...prev, startDate: newValue }));
  };

  const handleCreateRule = async () => {
    if (!validateForm()) return;

    setIsSubmitting(true);

    const ruleTypeMap = {
      "Brand": "BRAND",
      "Variant": "VARIANT",
      "Product": "PRODUCT",
      "MVID": "MANUFACTURER_VARIANT",
      "OfferPrice": "OFFER_PRICE"
    };

    let payload = {
      type: "WAREHOUSE",
      reference_id: reference_id,
      start_date: format(formData.startDate, "yyyy-MM-dd"),
      rule_type: ruleTypeMap[formData.ruleType],
      condition: formData.validationType,
      value: formData.slotCount,
      max_price: formData.ruleType === "OfferPrice" ? parseFloat(formData.maxPrice) : null,
      rule_type_id: formData.ruleType === "OfferPrice" ? [] : formData.names.map((item) => item.mvid || item.mvId || item.id),
    };

    props.getDataFromAPI(
      `/partner/api/v1/assortment/rule/create`,
      "POST",
      payload,
      (response) => {
        setIsSubmitting(false);

        const failures = response.rule_failures;

        if (failures) {
          toastr.warning("", failures);
        } else {
          toastr.success("Rule created successfully!");
        }

        setNewRuleId(response.id);
        setNewWarehouseName(response.reference_name);
        setShowSuccessModal(true);
      },
      (err) => {
        setIsSubmitting(false);
        toastr.error("Error", err.message || "Failed to create assortment");
        console.error("Rule update error:", err);
      }
    );
  };

  const handleCloseSuccessPopup = () => {
    setShowSuccessPopup(false);
    navigate(-1);
  };

  return (
    <WarehouseNewRuleCreationComponent
      formData={formData}
      searchInput={searchInput}
      searchResults={formData.ruleType === "MVID" ? filteredMvList : searchResults}
      searchLoading={searchLoading}
      showDropdown={formData.ruleType === "MVID" ? showMvIdDropdown : showDropdown}
      errors={errors}
      isSubmitting={isSubmitting}
      ruleTypes={[
        { value: "Brand", label: "Brand", icon: brandicon },
        { value: "Variant", label: "Variant", icon: varianticon },
        { value: "Product", label: "Product", icon: producticon },
        { value: "MVID", label: "MVID", icon: mvidicon },
        { value: "OfferPrice", label: "Offer Price", icon: offerpriceicon }
      ]}
      onChange={handleChange}
      onSearchInputChange={handleSearchInputChange}
      onAddName={handleAddName}
      onRemoveName={handleRemoveName}
      onSlotCountChange={handleSlotCountChange}
      onSubmit={handleCreateRule}
      onDateChange={handleDateChange}
      showSuccessModal={showSuccessModal}
      newRuleId={newRuleId}
      setShowSuccessModal={setShowSuccessModal}
      newWarehouseName={newWarehouseName}
      showRuleFailurePopup={showRuleFailurePopup}
      setShowRuleFailurePopup={setShowRuleFailurePopup}
      ruleFailureData={ruleFailureData}
      lastUpdatedTime={lastUpdatedTime}
      showSuccessPopup={showSuccessPopup}
      successData={successData}
      showMaxItemsPopup={showMaxItemsPopup}
      handleCloseSuccessPopup={handleCloseSuccessPopup}
      isMvidSearch={formData.ruleType === "MVID"}
      ruleFailures={ruleFailures}
      showFailureModal={showFailureModal}
      setShowFailureModal={setShowFailureModal}
      onMvidSearch={handleMvidSearch}
    />
  );
};

function mapStateToProps(state) {
  return {
    props: state
  };
}

export default connect(mapStateToProps, { getDataFromAPI })(WarehouseNewAssortmentRuleCreationContainer);